<template>
  <section class="info-box">
    <div class="info-box_aside">
      <i class="icons icons-error" />
    </div>
    <div class="info-box_main">
      <h6 class="subheading-1 info-box_title">{{ infoTitle }}</h6>
      <p class="info-box_text">{{ infoText }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InfoBox',
  props: {
    infoTitle: {
      type: String,
      default: '',
    },
    infoText: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
  .info-box {
    display: flex;
    padding: 4px 16px;
    background: #FCECE7;
    border-radius: 4px;
  }
  .info-box_aside {
    flex: 0 0 auto;
    color: $color-red;
    font-size: 24px;
    padding-right: 8px;
  }
  .info-box_main {
    flex: 1;
    padding: 5px 0;
  }
  .info-box_title {
    margin: 0 0 2px 0;
  }
  .info-box_text {
    margin-bottom: 0;
  }
</style>
